import { Menu, MenuItem } from '@mui/material';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  && .MuiPaper-root {
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }

  && .MuiMenu-list {
    padding: 0;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  font-size: 0.9rem;
  padding: 0.35rem 1rem;
`;

export const StyledMenuLabel = styled.span`
  padding-left: 0.3rem;
`;
